import { render, staticRenderFns } from "./ComonFotter.vue?vue&type=template&id=074dcc9b&scoped=true"
import script from "./ComonFotter.vue?vue&type=script&lang=js"
export * from "./ComonFotter.vue?vue&type=script&lang=js"
import style0 from "./ComonFotter.vue?vue&type=style&index=0&id=074dcc9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074dcc9b",
  null
  
)

export default component.exports